import { createFileRoute, useNavigate, useSearch } from "@tanstack/react-router";
import { z } from "zod";
import { MenuItemsListing, type MenuItemsListingSearchParams } from "@/components/menus";

const menusSearchSchema = z.object({
  page: z.number().catch(1),
  pageSize: z.number().catch(50),
  search: z.string().optional(),
  sortBy: z.string().optional(),
  sortOrder: z.enum(["asc", "desc"]).optional(),
  // The menu category filtered to (YC-42). An old `?category=` text link is dropped.
  categoryId: z.number().optional().catch(undefined),
  // The picked organization and concept, so Back from a menu item restores them.
  organizationId: z.number().optional().catch(undefined),
  companyId: z.number().optional().catch(undefined),
});

export const Route = createFileRoute("/(protected)/_layout/menus/")({
  validateSearch: (search) => menusSearchSchema.parse(search),
  component: MenusPage,
});

function MenusPage() {
  const searchParams = useSearch({ from: "/(protected)/_layout/menus/" });
  const navigate = useNavigate();

  const onNavigate = (
    updater: (prev: MenuItemsListingSearchParams) => MenuItemsListingSearchParams,
  ) => void navigate({ from: "/menus/", search: updater, replace: true });

  return <MenuItemsListing searchParams={searchParams} onNavigate={onNavigate} />;
}
